import D3Rating from './d3Rating'
export default D3Rating
